.dg{user-select:none;}